"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.translationsSlice = exports.fetchTranslations = void 0;
const toolkit_1 = require("@reduxjs/toolkit");
const app_1 = require("@/Endpoints/app");
const initialState = {
    translations: [],
    isLoading: false,
    isReady: false
};
exports.fetchTranslations = (0, toolkit_1.createAsyncThunk)('translations', () => __awaiter(void 0, void 0, void 0, function* () {
    return yield (0, app_1.getTranslationsData)().then(data => data.data);
}));
exports.translationsSlice = (0, toolkit_1.createSlice)({
    name: 'translations',
    initialState,
    reducers: {},
    extraReducers: builder => {
        builder.addCase(exports.fetchTranslations.pending, state => {
            state.isLoading = true;
        });
        builder.addCase(exports.fetchTranslations.fulfilled, (state, action) => {
            state.translations = action.payload;
            state.isLoading = false;
            state.isReady = true;
        });
        builder.addCase(exports.fetchTranslations.rejected, state => {
            state.isLoading = false;
        });
    }
});
exports.default = exports.translationsSlice.reducer;
